var __jsx = React.createElement;
import React from "react";
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import { useTranslation } from "@i18n";
import RejectedIcon from "@/pages/checkout/dhamen/icons/RejectedIcon";
import ContactModal from "@/pages/checkout/dhamen/components/common/ContactModal";
import useBoolean from "@hooks/useBoolean";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import useHelpers from "@hooks/useHelpers";
function OfferRejectedByDhamen() {
  var _state$orderInfo, _state$orderInfo$sale;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var contactModal = useBoolean();
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoScreen, {
    icon: /*#__PURE__*/React.createElement(RejectedIcon, null),
    title: tShort("dhamen/rejected_by_dhamen_title"),
    text: tShort("dhamen/rejected_by_dhamen_text"),
    primaryButton: {
      label: tShort("dhamen/contact_request_manager"),
      onClick: contactModal.setTrue
    },
    secondaryButton: {
      label: tShort("dhamen/back_to_home"),
      onClick: function onClick() {
        return navigateTo("/");
      }
    }
  }), /*#__PURE__*/React.createElement(ContactModal, {
    open: contactModal.value,
    onClose: contactModal.setFalse,
    toggle: contactModal.toggle,
    title: tShort("dhamen/contact_us_via"),
    phoneNumber: state === null || state === void 0 ? void 0 : (_state$orderInfo = state.orderInfo) === null || _state$orderInfo === void 0 ? void 0 : (_state$orderInfo$sale = _state$orderInfo.sales_user) === null || _state$orderInfo$sale === void 0 ? void 0 : _state$orderInfo$sale.phone_number
  }));
}
export default OfferRejectedByDhamen;